<template>

    <v-container>
        <div class="text-xs-center pt-2">
            <h2>Δηλώσεις Συγγραμμάτων</h2>
            <hr/>
            <v-alert :value="utils.checkIfN2plusBooksDeliveredFalse()" class="rounded-alert" outline>
                <small>Υπάρχει εκκρεμότητα επιστροφής βιβλίων,
                    τα οποία παραλάβατε κατ'απόκλιση του κανονισμού διανομής συγγραμμάτων.
                     Παρακαλούμε για την επιστροφή των εν λόγω συγγραμμάτων στη βιβλιοθήκη του Ιδρύματός σας.
                </small>
            </v-alert>
        </div>
        <br/>

        <v-container fluid>


            <v-layout align-end fill-height justify-space-between row>
                <v-flex xs1>

                </v-flex>
                <v-flex xs3>
                    <div class="text-xs-center pt-1">
                        <h2>Ιστορικό Δηλώσεων</h2>
                    </div>
                </v-flex>
                <v-flex class="mr-4" xs1>
                    <v-layout align-center justify-end row>
                        <v-tooltip left>
                            <v-btn :disabled="!declarationButton"
                                   @click="newDeclarationButton"
                                   color="error"
                                   round
                                   slot="activator">
                                <span class="editButton">Νέα δήλωση</span>
                                <v-icon>add</v-icon>
                            </v-btn>
                            <span>Δημιουργία νέας δήλωσης</span>
                        </v-tooltip>
                    </v-layout>
                </v-flex>
            </v-layout>

            <hr/>


            <v-data-table
                    :headers="headers"
                    :items="$store.getters.statement"
                    :pagination.sync="pagination"
                    class="elevation-6"
                    hide-actions
                    no-data-text="Δεν υπάρχουν διαθέσιμες δηλώσεις">
                <v-progress-linear color="primary" indeterminate slot="progress"></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.date }}</td>
                    <td class="text-xs-left">{{ props.item.year }}</td>
                    <td class="text-xs-left" v-if="props.item.period === 'Earino'">Εαρινό</td>
                    <td class="text-xs-left" v-else>Χειμερινό</td>
                    <td class="text-xs-right">
                        <v-tooltip left v-if="checkedIfActiveStatement(props.item.dataEntryAllowed)">
                            <v-btn @click="statementBookList(props.item)"
                                   color="info"
                                   round
                                   slot="activator">
                                <span class="editButton">Ενημέρωση</span>
                                <v-icon>replay</v-icon>
                            </v-btn>
                            <span>Ενημέρωση τρέχουσας δήλωσης</span>
                        </v-tooltip>
                        <v-tooltip left v-else>
                            <v-btn @click="statementBookList(props.item)"
                                   color="secondary"
                                   round
                                   slot="activator">
                                <span class="editButton">Επισκόπηση</span>
                                <v-icon>subject</v-icon>
                            </v-btn>
                            <span>Επισκόπηση δήλωσης</span>
                        </v-tooltip>
                    </td>
                </template>
                <template slot="no-data">
                    <v-alert icon="warning" type="error" value="true">
                        Δεν υπάρχουν διαθέσιμες δηλώσεις
                    </v-alert>
                </template>
            </v-data-table>

            <div class="text-xs-center pt-2">
                <v-pagination :length="pages" v-model="pagination.page"></v-pagination>
            </div>

        </v-container>
    </v-container>
</template>

<script>

    import requests from "../../requests";
    import utils from "../../utilities";

    export default {
        name: "StatementPage",
        data() {
            return {
                semesterArray: [],
                coursesArrayId: [],
                actionStatement: 4,
                pagination: {},
                headers: [
                    {
                        text: 'Ημερομηνία',
                        align: 'left',
                        sortable: false
                    },
                    {text: 'Έτος', align: 'left', sortable: false},
                    {text: 'Περίοδος', align: 'left', sortable: false},
                    {text: 'Ενέργειες',class: 'right mr-5 my-3',sortable: false}
                ],
                utils
            }
        },
        methods: {
            statementBookList(item) {
                var pin = {};
                const statement = {};
                const redeem = {};

                if (item.hasOwnProperty('statementAddress')) {
                    this.$store.commit('setStudentAddressInformation', true);
                    this.$store.commit('setStatementAddress', item.statementAddress);
                }
                else {
                    this.$store.commit('setStudentAddressInformation', false);
                    this.$store.commit('setStatementAddress', {});
                }

                if (!this.checkedIfActiveStatement(item.dataEntryAllowed)) {
                    // Episkopisi

                    // check if ExchangeTypeComponent visibility
                    utils.checkExchangeTypeComponentVisibility(item);

                    for (var i = 0; i < item.bookGroups.length; i++) {
                        this.coursesArrayId[i] = item.bookGroups[i].courseId;
                    }
                    this.$store.commit('setNewStatementAllow', false);
                    this.$store.commit('setPinFlag', false);
                    this.checkIfExistLinkedBook(item);
                    requests.freebookCourses(this.coursesArrayId, this.createListOfEbooksById);
                    this.$router.push({path: '/statementBookList'});

                } else {
                    // Enimerosi
                    this.$store.commit('setNewStatementAllow', true);
                    this.$store.commit('setPinFlag', true);
                    if (this.$store.getters.active.dataEntryAllowed === true) {
                        this.$store.commit('setLoadingModal', true);
                        this.checkIfExistLinkedBook(item);
                        requests.allCourses(this.$store.getters.login.secretariat.id, this.createCoursesArrayId);
                    }
                }

                for (var i in item.bookGroups) {
                    if (item.bookGroups[i].statementBookGroupType == 'NORMAL') {
                        statement[item.bookGroups[i].courseId] = {
                            books: item.bookGroups[i],
                            date: item.date,
                            period: item.period
                        };
                    } else {
                        if (item.bookGroups[i].books.length > 0) {
                            redeem[item.bookGroups[i].books[0].book.id] = {
                                books: item.bookGroups[i],
                                date: item.date,
                                period: item.period
                            };
                        }
                    }
                }

                pin = {pin: item.pin , id: item.id};
                this.$store.commit('setStatementComplete', pin);
                this.$store.commit('setCheckedBooks', statement);
                this.$store.commit('setRedeemPoints', redeem);
            },

            checkIfExistLinkedBook(item) {
                var login = this.$store.getters.login;
                var linkedCourseId = [];

                for (var i in item.bookGroups) {
                    if (item.bookGroups[i].course.secretariatID != login.secretariat.id) {
                                linkedCourseId.push(item.bookGroups[i].courseId);
                    }
                }
                if (linkedCourseId.length) {
                    requests.freebookCourses(linkedCourseId, this.createsListLinkedEbooksById);
                }

            },

            createCoursesArrayId(response) {
                for (let i = 0; i < response.data.length; i++) {
                    this.coursesArrayId[i] = response.data[i].id;
                }
                this.$store.commit('setCourses', response.data);
                this.$store.commit('setSemesters', utils.getSemestersFromActive(response.data, this.$store.getters.login.statementMaxCourseSemester));
                requests.freebookCourses(this.coursesArrayId, this.createListOfEbooksById);
                requests.allBooksGroupByCourse(this.$store.getters.login.secretariat.id, this.createListOfBooksById);
                requests.selectedDepartment(this.successSelectedDepartment);

            },
            successSelectedDepartment(response){
                var setLinkedSemesterData = {};
                for (var i=0; i < response.length;i++){
                    setLinkedSemesterData[response[i].secretariatId] = null;
                    response[i].message = ""
                }
                this.$store.commit('setLinkedSemesterData', setLinkedSemesterData);
                this.$store.commit('setSelected', response);
            },

            createListOfBooksById(response) {
                this.$store.commit('setListOfBooksById', utils.checkIfBookIsActiveFromSecretary(response));
                this.createListSemesterData();
            },

            createListSemesterData() {
                var semesterArray = this.$store.getters.semesters;
                this.semesterCoursesArray = [];
                const courses = this.$store.getters.courses;
                for (var i = 0; i < semesterArray.length; i++) {
                    var semesterCourses = [];
                    var semester = semesterArray[i];

                    for (var j = 0; j < courses.length; j++) {
                        var courseItem = courses[j];
                        if (courseItem.semester === semester)
                            semesterCourses.push(courseItem);
                    }

                    this.semesterCoursesArray.push({semester: semester, courses: semesterCourses});
                }
                this.finalCoursesData()

            },

            finalCoursesData() {

                var semesterData = utils.getSemesterData(this.$store.getters.listOfBooksById, this.semesterCoursesArray, this.$store.getters.checkedBooks, this.$store.getters.login.secretariat.id);
                // var linkedSemesterData = utils.getSemesterData(this.$store.getters.listOfBooksById, this.semesterCoursesArray, this.$store.getters.checkedBooks);
                // this.$store.commit('setLinkedSemesterData', linkedSemesterData);
                this.$store.commit('setSemesterData', semesterData);
                this.$store.commit('setLoadingModal', false);
                this.$router.push({path: '/statementBookList'});

            },

            createListOfEbooksById(response) {
                this.$store.commit('setListOfEbooksById', response);
            },
            createsListLinkedEbooksById(response) {
              this.$store.commit('setListLinkedEbooks', response);
            },

            newDeclarationButton() {
                this.$store.commit('setCourseRegistration' , []);
                this.$store.commit('setCheckedBooks', {});
                this.$store.commit('setRedeemPoints', {});
                this.$router.push({path: '/termConditions'})
            },

            checkUpdateDeclaration() {
                this.actionStatement = 1;
                var active = this.$store.getters.active;
                var statement = this.$store.getters.statement;
                for (var i = 0; i < statement.length; i++) {
                    if (statement[i].id === active.id) {
                        this.actionStatement = 1;
                    }
                }
            },

            initialize() {
                if (this.$store.getters.activeDeclaration == true &&
                    this.$store.getters.completeDialog == false) {
                    this.$store.commit('setNewStatementAllow', true);
                } else {
                    this.$store.commit('setNewStatementAllow', false);
                }
            },

            checkedIfActiveStatement(dataEntryAllowed) {
                var isPersistedStatement = false;
                if (this.$store.getters.active.hasOwnProperty("id")) {
                    isPersistedStatement = true;
                }

                if (dataEntryAllowed && isPersistedStatement) {
                    if (isPersistedStatement && dataEntryAllowed) {
                        return true
                    } else {
                        if (isPersistedStatement) {
                            return false
                        } else {
                            if (this.isNPlus2OrKatataktirios()) {
                                //    Παραλαβή συγγραμμάτων από Ανταλλαγή (Eudoxus+)
                            } else {
                                //    Δημιουργία νέας δήλωσης
                                this.$store.commit('setNewStatementAllow', true);
                            }
                        }
                    }
                }
            },

            isNPlus2OrKatataktirios() {
                var login = this.$store.getters.login;
                if (login.borrowed != null) {
                    var borrowed = login.borrowed
                }
                return borrowed || this.isKatataktirios(login)

            },

            isKatataktirios(login) {
                if (login.inArrangementsBlackListByStatement != null) {
                    var inArrangementsBlackListByStatement = login.inArrangementsBlackListByStatement;
                }
                if (login.inArrangementsBlackListByInstitution != null) {
                    var inArrangementsBlackListByInstitution = login.inArrangementsBlackListByInstitution
                }
                return inArrangementsBlackListByStatement || inArrangementsBlackListByInstitution
            }
        },
        created() {
            this.checkedIfActiveStatement();
            this.checkUpdateDeclaration();
            this.initialize();
        },
        mounted() {
            utils.removeDatatableLoadingElement();
        },
      computed: {
            pages() {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0;

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            },
            declarationButton: function () {
                return this.$store.getters.active.dataEntryAllowed == true && !this.$store.getters.active.hasOwnProperty("id") && !utils.checkIfN2plusBooksDeliveredFalse();
            }
        }
    }
</script>

<style scoped>
    .editButton {
        font-size: small;
        padding-right: 5px;
    }
</style>
